const appConfig = {
    appId: "licenseQore-48908b30-3392-4d96-bb9b-1bea3b8da030",
    appName: "Licensing",
    site: 'licensing-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/licenseQoreAppIcon.png"
};

export default appConfig;
